<template>
  <div class="container mt-5">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">

          <div class="page-header">
            <h1 class="title is-3 mb-2">Admin</h1>

            <p class="subtitle is-6 has-text-grey">
                Manage user accounts and review storage usage.
            </p>
          </div>

          <div class="admin-grid">
            <router-link to="/users" class="admin-card">
              <span class="icon admin-icon">
                <i class="fas fa-users"></i>
              </span>

              <div>
                <h2 class="title is-5 mb-1">Manage Users</h2>
                <p class="has-text-grey">
                  View, create, and update user accounts.
                </p>
              </div>
            </router-link>

            <router-link to="/admin/disk-usage" class="admin-card">
              <span class="icon admin-icon">
                <i class="fas fa-hdd"></i>
              </span>

              <div>
                <h2 class="title is-5 mb-1">Disk Usage</h2>
                <p class="has-text-grey">
                  Review storage usage for photos, PDFs, and server files.
                </p>
              </div>
            </router-link>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminView',

  mounted() {
    document.title = 'Admin | SCE Electrical'
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 1.5rem;
}

.admin-grid {
  display: grid;
  gap: 1rem;
}

.admin-card {
  display: flex;
  align-items: center;
  gap: 1rem;

  padding: 1.25rem;
  border: 1px solid #eeeeee;
  border-radius: 12px;

  background: white;
  color: inherit;
  text-decoration: none;

  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.admin-card:hover {
  transform: translateY(-2px);
  border-color: #dcdcdc;
  box-shadow: 0 0.75rem 1.5rem rgba(10, 10, 10, 0.08);
}

.admin-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 999px;
  background: #f5f5f5;
  color: #3273dc;

  font-size: 1.25rem;
}

@media screen and (max-width: 768px) {
  .admin-card {
    align-items: flex-start;
  }
}
</style>